module.exports = __webpack_public_path__ + "static/media/cv_3.059fdbbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/cv_3.png
// module id = 615
// module chunks = 0